var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-wrap"},[_c('st-header',{attrs:{"close-able":true,"back-able":true}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticStyle:{"height":"100%"}})])
}]

export { render, staticRenderFns }